module.exports = __webpack_public_path__ + "assets/ic-github.f494c174.svg";